module.exports = __webpack_public_path__ + "img/cm.f45349e7.svg";